<template>
  <div class="p-chat-star-rating">
    <div class="p-chat-star-rating__stars">
      <button
        v-for="i in 5"
        :key="i"
        type="button"
        class="p-chat-star-rating__star-btn"
        :class="{ 'p-chat-star-rating__star-btn--active': rating >= i }"
        :disabled="readOnly"
        :aria-label="`${i} yıldız`"
        @click="handleClick(i)"
      >
        <p-icon
          icon="star-ratings"
          size="xxl"
          :class="rating >= i ? 't-fg-rating-star' : 't-passive-states-disabled-fg'"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  rating?: number
  readOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  rating: 0,
  readOnly: false,
})

const emit = defineEmits<{
  rate: [stars: number]
}>()

const handleClick = (stars: number) => {
  if (props.readOnly) return
  emit('rate', stars)
}
</script>

<style lang="scss" scoped>
// Figma node 5192:16607 — Chat Info Rating variant
// Stars row spans full chat width with space-between distribution.
// No "Hiç memnun kalmadım / Çok memnun kaldım" labels per Figma.

.p-chat-star-rating {
  display: flex;
  flex-direction: column;
  // Span the parent's full width so `justify-content: space-between` on
  // __stars actually distributes across the chat body. Parent rating-row
  // uses `align-items: center` which would otherwise content-width us.
  width: 100%;

  &__stars {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__star-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 4px;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.15s;
    flex-shrink: 0;

    &:not(:disabled):hover {
      background-color: var(--bg-gray-light);
    }

    &:disabled {
      cursor: default;
    }
  }
}
</style>
